import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--boards"
export default class extends Controller {
  static targets = ["boardTargetParent", "boardTargetFacltyParent", "boardTargetChild"]

  initialize() {
    this.boardTargetFacltyParentTargets.forEach(function(el) {
      const boardTargetChildElments = this.boardTargetChildTargets.filter(x => el.value.split(' ').includes(x.value))

      if(boardTargetChildElments.map(x => x.checked).includes(false)) {
        el.checked = false
      } else {
        el.checked = true
      }
    }.bind(this));

    // 学部に紐づく学科コースが全てチェックされている場合、紐づく「○○学部全て」の要素をチェックする
    // 全てチェックされていない場合、紐づく「○○学部全て」の要素のチェックを外す
    if(this.boardTargetChildTargets.map(x => x.checked).includes(false)) {
      this.boardTargetParentTarget.checked = false
    } else {
      this.boardTargetParentTarget.checked = true
    }
  }

  // 全学生がチェックされている場合、学科コースの要素を全てチェックする
  // チェックを外された場合、学科コースの要素の全てのチェックを外す
  toggleChild() {
    this.boardTargetFacltyParentTargets.map(x => x.checked = this.boardTargetParentTarget.checked)
    this.boardTargetChildTargets.map(x => x.checked = this.boardTargetParentTarget.checked)
  }

  // 「○○学部全て」がチェックされた場合、紐づく学科コースの要素全てにチェックする
  // チェックを外された場合、紐づく学科コースの要素全てのチェックを外す
  toggleFacultySubjectCourses(event) {
    const facltyParentIds = event.target.value.split(' ');
    const facultySubjectCourseElements = this.boardTargetChildTargets.filter(x => facltyParentIds.includes(x.value))

    facultySubjectCourseElements.map(x => x.checked = event.target.checked)

    if(this.boardTargetFacltyParentTargets.map(x => x.checked).includes(false)) {
      this.boardTargetParentTarget.checked = false
    } else {
      this.boardTargetParentTarget.checked = true
    }
  }

  toggleParent(event) {
    // チェックした学科コースに紐づく「○○学部全て」の要素を取得
    const boardTargetFacltyParentElements = this.boardTargetFacltyParentTargets.find(x => x.value.split(' ').includes(event.target.value))
    // チェックした学科コースと同じ学部に紐づく学科コースの要素を全て取得
    const boardTargetChildElments = this.boardTargetChildTargets.filter(x => boardTargetFacltyParentElements.value.split(' ').includes(x.value))

    // 学部に紐づく学科コースが全てチェックされている場合、紐づく「○○学部全て」の要素をチェックする
    // 全てチェックされていない場合、紐づく「○○学部全て」の要素のチェックを外す
    if(boardTargetChildElments.map(x => x.checked).includes(false)) {
      boardTargetFacltyParentElements.checked = false
    } else {
      boardTargetFacltyParentElements.checked = true
    }

    // 学科コースの要素が全てチェックされている場合、「全学生」にチェックする
    if(this.boardTargetChildTargets.map(x => x.checked).includes(false)) {
      this.boardTargetParentTarget.checked = false
    } else {
      this.boardTargetParentTarget.checked = true
    }
  }
}
